import { ALL_FILTER_PRESET, FilterPreset, FilterItem } from '../models/filters';

import { ratingTextMap } from '../components/common/rating-text-label';

export const mapRatingsFilter: (x: FilterPreset<number>) => FilterItem<number> =
    (x: FilterPreset<number>) => x === ALL_FILTER_PRESET
        ? { name: 'All ratings', value: x }
        : { name: ratingTextMap[x], value: x };
